








































































import { Component, Prop } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import { IMember, IMemberListRequest } from "@/types/member";
import { IPagination } from "@/types";
import List from "@/components/basic/List.vue";
import { MemberListRequest } from "@/models/member";
import {
  IProposalStatus,
  IProposalStatusListRequest,
} from "@/types/proposalStatus";

@Component({})
export default class extends List {
  @Action("member/adminGetList")
  public memberGetList!: (params: IMemberListRequest) => Promise<boolean>;

  @Getter("member/list")
  public membersList!: IMember[];

  @Getter("member/pagination")
  public pagination!: IPagination<IMember>;

  @Mutation("member/clear")
  protected clear!: () => void;

  @Getter("member/single")
  public member!: IMember;

  @Action("proposalStatus/getList")
  public getStatuses!: (params: IProposalStatusListRequest) => Promise<void>;

  @Getter("proposalStatus/list")
  public proposalStatuses!: IProposalStatus[];

  @Prop({
    default: new MemberListRequest(),
  })
  public condition!: IMemberListRequest;

  public params: IMemberListRequest = new MemberListRequest();

  public headers = [
    {
      text: "",
      align: "center",
      value: "attachment",
    },
    { text: "名前", value: "name", sortable: false },
    { text: "性別", value: "gender", sortable: false },
    { text: "年齢", value: "age", sortable: false },
    { text: "最寄り", value: "place", sortable: false },
    { text: "希望条件", value: "condition", sortable: false },
    { text: "案件提案の状態", value: "state", sortable: false },
    // { text: "実績", value: "history", sortable: false },
  ];
  count: number[] = [];

  public async mounted(): Promise<void> {
    await this.getStatuses({ per_page: 0 });
  }

  public async getList(): Promise<void> {
    this.loading = true;
    this.params = this.condition;
    await this.memberGetList(this.params);
    this.loading = false;
    this.paramsToQuery();
  }

  public rowClick(member: IMember): void {
    this.$router.push({
      name: "SalesMemberDetail",
      params: { member_id: member.id.toString() },
    });
  }
}
